export const en = {
  misc: {
    storeName: 'Fable',
  },
  welcome: 'Welcome to Fable',
};
